import { useEffect, useRef, useState } from 'react'

import internalApiQueryWrapper from '../../core/internalApiQueryWrapper'
import Social from '../ComponentMap/Social'
import { track } from '../utilities/track'
import Body from './Body'
import Byline from './Byline'
import Hero from './deprecated_Hero'

const StoryDetails = ({ collection, story }) => {
  const categories = story?.categories?.map(category => category?.fields?.name)
  const [moreStories, setMoreStories] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)

  const isFirstRender = useRef(true)

  useEffect(() => {
    track('On_Story_Page', {
      storyCategory: categories?.[0],
      storyAuthor: story?.authors?.map(author => author?.fields?.byline)
    })

    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
  }, [isFirstRender])

  useEffect(() => {
    const loadStories = async () => {
      setLoading(true)
      try {
        const data = await internalApiQueryWrapper('/api/contentful/collection', {
          regions: collection.region,
          categories: collection.id,
          skip: moreStories.length,
          limit: 3
        })
        setMoreStories(prevMoreStories => [...prevMoreStories, ...data.stories])
        setTotal(data.total)
      } catch (err) {
        /* c8 ignore next */
        console.error(err)
      } finally {
        setLoading(false)
      }
    }
    loadStories().catch(err => console.error(err))
  }, [])

  const adProps = {
    /* 'leaderboard' prop is temporarily now,
       it's here just to not break the layouts other than Article.
       sooner or later will be deprecated and
       'leaderboardNew' will be used app wide
    */
    leaderboard: {
      node: { attribs: { 'data-size': 'leaderboard' } },
      contentfulCategories: categories
    },
    leaderboardNew: {
      node: { attribs: { 'data-size': 'leaderboardNew' } },
      contentfulCategories: categories
    },
    middleboard: {
      node: { attribs: { 'data-size': 'middleboard' } },
      contentfulCategories: categories
    },
    sidebar1: {
      node: { attribs: { 'data-size': 'sidebar1' } },
      contentfulCategories: categories
    },
    sidebar2: {
      node: { attribs: { 'data-size': 'sidebar2' } },
      contentfulCategories: categories
    },
    postscript: {
      node: { attribs: { 'data-size': 'postscript' } },
      contentfulCategories: categories
    },
    taboola: {
      node: {
        attribs: {
          'data-size': 'taboola',
          'data-config':
            '{ "mode": "alternating-thumbnails-a",  "container": "taboola-feed---below-article-thumbnails",  "placement": "Feed - Below article thumbnails",  "target_type": "mix"  }'
        }
      },
      contentfulCategories: categories
    }
  }

  return (
    <div data-testid='story-details'>
      <div className='renderable article'>
        <div className='container horizontal normal article'>
          <div className='banner-top'>
            {story?.withAds && <AdUnit adUnitTemplate='leaderboard' id={'ad-banner-top'} type='leaderboardNew' />}
          </div>
          <div className='section article-content'>
            <div className='mobile-background-wrapper'>
              <h1 className='heading'>{story?.title}</h1>
              <Byline story={story} />
              <Hero story={story} withAds={story?.withAds} />
              <Body body={story?.body} content={story?.content} />
              <div className='share-icons'>
                <span>Share this story</span>
                <Social node={{ attribs: { 'data-slug': story?.slug } }} />
              </div>
              {/* Hiding More Stories section for a time being, until we figure out the correct position with Taboola and mobile app is released*/}
              {/*{!!moreStories?.length && <MoreStories moreStories={moreStories} loadMore={loadStories} loading={loading} total={total} />}*/}
              {story?.withAds && (
                <div className='banner-middle'>
                  <AdUnit adUnitTemplate='leaderboard' id={'ad-banner-middle'} type='middleboard' />
                </div>
              )}
            </div>
            <div className='minute-top-video-container' id='minute-top-video-container' />
            {story?.withAds && (
              <>
                <AdUnit adUnitTemplate='leaderboard' id={'ad-banner-postscript'} type='postscript' />
                <AdUnit adUnitTemplate='leaderboard' id={'ad-banner-taboola'} type='taboola' />
              </>
            )}
          </div>
          {story?.withAds && (
            <div className='section sidebar'>
              <AdUnit adUnitTemplate='rectangleVertical' id={'ad-banner-sidebar-top'} type='sidebar1' />
              <AdUnit adUnitTemplate='rectangleVertical' id={'ad-banner-sidebar-bottom'} type='sidebar2' />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default StoryDetails
